import state from './moduleEInvoiceState.js'
import mutations from './moduleEInvoiceMutation.js'
import actions from './moduleEInvoiceActions.js'
import getters from './moduleEInvoiceGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

